import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSection } from "../../../../assignmentSlice";
import ScrambleButton from "../../../widgets/ScrambleButton";

const ScramblePage = ({ currentPage, pageList, setPageList, currentIndex }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const [wordList, setWordList] = useState([]);

  useEffect(() => {
    if (currentPage.scramble) {
      setWordList(
        currentPage.scramble
          .filter((element) => element.type === "scramble")
          .map((element) => element.content)[0]
      );
    }
  }, [currentIndex]);

  const handleClickWord = (word) => {
    const prevInput =
      currentPage.scramble.find((element) => element.type === "scramble")
        .input || [];
    const currentInput = prevInput.some((input) => input.index === word.index)
      ? prevInput.filter((input) => input.index !== word.index)
      : [...prevInput, word];

    const isSubmitted = currentInput.length === wordList.length;

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          scramble: prevPage.scramble.map((element) => {
            if (element.type === "scramble") {
              return {
                ...element,
                input: currentInput,
              };
            }
            return element;
          }),
          isSubmitted: isSubmitted,
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "30px",
        width: "90%",
      }}
    >
      <div style={{ fontSize: "20px", marginBottom: "20px" }}>
        위 문장과 의미가 유사하도록, 아래의 문장을 완성하세요.
      </div>
      <div style={{ fontSize: "24px", marginBottom: "10px", color: "#2D2D2D" }}>
        {currentPage.question}
      </div>
      <div
        style={{
          fontSize: "28px",
          marginBottom: "20px",
        }}
      >
        {currentPage.scramble && (
          <div style={{ wordBreak: "break-word", display: "inline" }}>
            {currentPage.scramble
              .map((element) => {
                if (element.type === "scramble") {
                  const blankLength = element.length;
                  const userAnswer = element.input || [];

                  return userAnswer
                    .map((answer) => answer.text)
                    .join(" ")
                    .concat(" ")
                    .padEnd(blankLength, "_");
                } else {
                  return element.content;
                }
              })
              .join(" ")}
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        {wordList.length > 0 && (
          <ScrambleButton
            wordList={wordList.slice()}
            currentPage={currentPage}
            handleClickWord={handleClickWord}
            type={"comprehensive"}
          />
        )}
      </div>
    </div>
  );
};

export default ScramblePage;
